module.exports = __webpack_public_path__ + "static/media/logoNegative_iconSize.cf03dcff.svg";